import { render, staticRenderFns } from "./aiCourse.vue?vue&type=template&id=76826d21&scoped=true"
import script from "./aiCourse.vue?vue&type=script&lang=js"
export * from "./aiCourse.vue?vue&type=script&lang=js"
import style0 from "./aiCourse.vue?vue&type=style&index=0&id=76826d21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76826d21",
  null
  
)

export default component.exports